var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "phone",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12965",
    "data-name": "Path 12965",
    d: "M14,11.057a3.282,3.282,0,0,1-.1.7,3.95,3.95,0,0,1-.209.681,2.666,2.666,0,0,1-1.213,1.054A3.855,3.855,0,0,1,10.629,14a3.946,3.946,0,0,1-.527-.035,4.085,4.085,0,0,1-.572-.124q-.313-.089-.467-.144t-.552-.2q-.4-.149-.487-.179a9.005,9.005,0,0,1-1.74-.825,14.987,14.987,0,0,1-2.625-2.148A14.987,14.987,0,0,1,1.511,7.716a9.005,9.005,0,0,1-.825-1.74q-.03-.089-.179-.487T.3,4.937Q.249,4.783.159,4.469A4.085,4.085,0,0,1,.035,3.9,3.946,3.946,0,0,1,0,3.371,3.855,3.855,0,0,1,.507,1.521,2.666,2.666,0,0,1,1.561.308,3.95,3.95,0,0,1,2.242.1a3.282,3.282,0,0,1,.7-.1.557.557,0,0,1,.209.03q.179.06.527.756.109.189.3.537t.348.631q.159.283.308.532.03.04.174.249a2.777,2.777,0,0,1,.214.353.649.649,0,0,1,.07.283.825.825,0,0,1-.283.5,4.847,4.847,0,0,1-.616.547,5.988,5.988,0,0,0-.616.527.757.757,0,0,0-.283.457.672.672,0,0,0,.05.224,2.171,2.171,0,0,0,.085.2q.035.07.139.239t.114.189a10.437,10.437,0,0,0,1.73,2.337,10.437,10.437,0,0,0,2.337,1.73q.02.01.189.114t.239.139a2.17,2.17,0,0,0,.2.085.672.672,0,0,0,.224.05.757.757,0,0,0,.457-.283,5.988,5.988,0,0,0,.527-.616,4.847,4.847,0,0,1,.547-.616.825.825,0,0,1,.5-.283.649.649,0,0,1,.283.07,2.777,2.777,0,0,1,.353.214q.209.144.249.174.249.149.532.308t.631.348q.348.189.537.3.7.348.756.527A.557.557,0,0,1,14,11.057Z",
    transform: "translate(0)",
    fill: "#600097"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a3a6f4f3a4fe7e00c8a12dbe9d3a8347.svg";
export { ForwardRef as ReactComponent };